module.exports = __webpack_public_path__ + "static/media/20210212_214852_703_IMG_2192.147d9af1.jpg";